export const GET_OPTIONS = 'OPTIONS/GET'
export const GET_OPTIONS_PENDING = 'OPTIONS/GET_PENDING'
export const GET_OPTIONS_SUCCESS = 'OPTIONS/GET_SUCCESS'
export const GET_OPTIONS_REJECTED = 'OPTIONS/GET_REJECTED'
